import React, { useState } from "react"
import { useRefetchRenewalData, useSetDoneWithCarrot } from "./useQueryCaseRateRenewals"
import { DoneForNowContent } from "./DoneForNowContent"
import { ThanksForLettingUsKnowContent } from "./ThanksForLettingUsKnowContent"
import { ErrorStep } from "./steps/ErrorStep"
import { Box, CloseIcon, Dialog, IconButton } from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"

export function NonStaleDoneUsingCarrotModal({
  openDoneUsingCarrotModal,
  setOpenDoneUsingCarrotModal,
  onBack
}: {
  openDoneUsingCarrotModal: boolean
  setOpenDoneUsingCarrotModal: (isDoneUsingModal: boolean) => void
  onBack?: () => void
}): JSX.Element {
  enum ModalContent {
    DONE_FOR_NOW,
    THANKS_FOR_LETTING_US_KNOW,
    ERROR
  }
  const { mutate, isLoading } = useSetDoneWithCarrot()
  const [modalContent, setModalContent] = useState(ModalContent.DONE_FOR_NOW)
  const refetchData = useRefetchRenewalData()
  const intl = useIntl()

  async function doneWithCarrot(): Promise<void> {
    mutate(null, {
      onSuccess: () => setModalContent(ModalContent.THANKS_FOR_LETTING_US_KNOW),
      onError: () => setModalContent(ModalContent.ERROR)
    })
  }

  async function closeModalAndRefetchData(): Promise<void> {
    setOpenDoneUsingCarrotModal(false)
    await refetchData()
  }

  const displayModalContent = [
    {
      modalContent: ModalContent.DONE_FOR_NOW,
      component: (
        <DoneForNowContent
          takeMeBackOnClick={onBack ?? (() => setOpenDoneUsingCarrotModal(false))}
          yesImDoneOnClick={doneWithCarrot}
          isLoading={isLoading}
        />
      )
    },
    {
      modalContent: ModalContent.THANKS_FOR_LETTING_US_KNOW,
      component: <ThanksForLettingUsKnowContent close={closeModalAndRefetchData} />
    },
    { modalContent: ModalContent.ERROR, component: <ErrorStep /> }
  ]

  return (
    <Dialog open={openDoneUsingCarrotModal}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton aria-label={intl.formatMessage({ defaultMessage: "close" })} onClick={closeModalAndRefetchData}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>{displayModalContent.find((content) => content.modalContent === modalContent).component}</Box>
    </Dialog>
  )
}
